import {
  Box,
  Flex,
  Text,
  Heading,
  VStack,
  Stack,
} from "@chakra-ui/react";
import { pmsFormHeaders } from "../utilities/uiConfigData";
import { useDispatch, useSelector } from "react-redux";
import { decrementPmsSearchStep } from "../redux/actions/layout";
import { ChevronLeftIcon } from "@chakra-ui/icons";

const SearchFormHeader = () => {
  const state = useSelector((state) => state);
  const step = state.layout.pmsSearchStep;
  const data = pmsFormHeaders[Number(step)];
  const dispatch = useDispatch();

  return (
    <Stack>
      <Flex
        alignItems="center"
        cursor="pointer"
        mb={4}
        onClick={() => dispatch(decrementPmsSearchStep())}
      >
        <ChevronLeftIcon color="brand.400" boxSize={8} />
        <Text color="brand.400">BACK</Text>
      </Flex>
      <Flex align="center" justify="flex-start" paddingLeft="16px">
        <Box
          height="60px"
          width="60px"
          borderRadius="50%"
          borderColor="green"
          borderWidth="1px"
          bg="white"
          marginRight="16px"
          marginBottom="20px"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Text textStyle="h2">{step + 1}</Text>
        </Box>
        <VStack align="flex-start">
          <Heading fontWeight={800} fontSize="1.5rem" color="brand.300">
            {data.title}
          </Heading>
          <Text fontSize="sm" color="brand.200">
            {data.description}
          </Text>
        </VStack>
      </Flex>
    </Stack>
  );
};

export default SearchFormHeader;
